// extracted by mini-css-extract-plugin
export default {"title":"add-to-cart-warning-popup__title___h03dE"};